import { Link } from "react-router-dom";

// Turns the first occurrence of each phrase in `links` into a link
const linkify = (text, links) => {
  for (const [phrase, href] of Object.entries(links)) {
    const i = text.indexOf(phrase);
    if (i === -1) continue;
    const before = linkify(text.slice(0, i), links);
    const after = linkify(text.slice(i + phrase.length), links);
    const cls = "text-primary hover:underline";
    const node = href.startsWith("/") ? <Link to={href} className={cls}>{phrase}</Link> : <a href={href} className={cls}>{phrase}</a>;
    return <>{before}{node}{after}</>;
  }
  return text;
};

const Block = ({ b, links }) => {
  if (typeof b === "string") return <p>{linkify(b, links)}</p>;
  if (Array.isArray(b)) {
    return (
      <ul className="list-disc pl-6 space-y-2 marker:text-primary">
        {b.map((li) => <li key={li}>{linkify(li, links)}</li>)}
      </ul>
    );
  }
  if (b.important) {
    return <p className="border-l-2 border-primary pl-4"><strong className="text-white">Important:</strong> {b.important}</p>;
  }
  if (b.external) {
    return <p>{b.external[0]}<a href={b.external[1]} target="_blank" rel="noopener noreferrer" className="text-primary hover:underline break-all">{b.external[1]}</a></p>;
  }
  return null;
};

// sections: [heading, ...blocks]; a block is a string (paragraph), array (bullets), {important} or {external: [text, url]}
export const LegalPage = ({ title, intro, updated, sections, links = {}, testId }) => (
  <div className="max-w-3xl mx-auto px-6 md:px-10 py-16" data-testid={testId}>
    <p className="label-xs">Legal</p>
    <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold mt-3" data-testid={`${testId}-title`}>{title}</h1>
    {updated && <p className="text-white/50 mt-4 text-sm">{updated}</p>}
    {intro && <p className="text-white/80 mt-8 text-lg">{intro}</p>}
    <div className="mt-12 space-y-12">
      {sections.map(([heading, ...blocks]) => (
        <section key={heading} className="space-y-4 text-white/75 leading-relaxed">
          <h2 className="font-display text-xl md:text-2xl text-white">{heading}</h2>
          {blocks.map((b, i) => <Block key={i} b={b} links={links} />)}
        </section>
      ))}
    </div>
  </div>
);
